import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SpecialistsSection from '../components/SpecialistsSection';
import PeopleIcon from '@mui/icons-material/People';
import DecorativeCubes from '../components/DecorativeCubes';

const SpecialistsPage = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <DecorativeCubes minCubes={6} maxCubes={10} />
      <Header />
      <Box sx={{ py: 8, backgroundColor: '#f9f9f9', position: 'relative', zIndex: 2 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <PeopleIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontWeight: 700,
                color: 'primary.main',
              }}
            >
              Наши специалисты
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Команда профессионалов консультационного центра
            </Typography>
          </Box>
        </Container>
      </Box>
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <SpecialistsSection />
      </Box>
      <Footer />
    </Box>
  );
};

export default SpecialistsPage;
